<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <date-input  type="date" class="date_form" :class="errorMessage ? 'is-invalid' : ''" :value="modelValue" :set-handler="setDateHandler" />
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span v-if="help" class="form-text">{{ help }}</span>
  </form-layout>
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem';
import FormLayout from "@/views/templates/FormLayout";
import DateInput from '@/views/atoms/inputs/DateInput.vue';

export default {
  name: "VuexTextFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    },
    setHandler: {
      type: Function,
      default: () => {
      }
    },
    modelValue: { 
      type: [String, Date, null],
      default: null
    }
  },
  emits: ['update:modelValue'],
  components: {
    FormLayout,
    DateInput
  },
  methods: {
    setDateHandler(payload) {
      this.$emit('update:modelValue', payload.value);
    },
  }
  
}
</script>

<style>
  .date_form{
    width: 10rem;
  }
</style>